import { APIClient } from '@frontend/api-utils';
import { WorkflowConditionTemplateResponse, WorkflowField } from '@frontend/workflow/types';

export class WorkflowTemplateClient extends APIClient {
    public static readonly endpoint = '/workflow-api/v1';

    public static async fetchWorkflowActionFieldTemplates(): Promise<{ [key: string]: WorkflowField[] }> {
        const response = await this.fetch(`${this.endpoint}/workflow-action-field-templates`);
        return await this.handleResponse<{ [key: string]: any[] }>(response);
    }

    public static async fetchWorkflowTriggerFieldTemplates(): Promise<{ [key: string]: WorkflowField[] }> {
        const response = await this.fetch(`${this.endpoint}/workflow-trigger-field-templates`);
        return await this.handleResponse<{ [key: string]: any[] }>(response);
    }

    public static async fetchWorkflowConditionTemplates(): Promise<WorkflowConditionTemplateResponse> {
        const response = await this.fetch(`${this.endpoint}/workflow-condition-templates`);
        return await this.handleResponse<WorkflowConditionTemplateResponse>(response);
    }
}
